// dependencies
import React, { PropsWithChildren } from "react";

import Button from "../../../Button";
import Text from "../../../Text";
// components
import Modal from "../../Modal";
// styles
import css from "./ConfirmationModal.module.scss";

interface BaseProps {
	/**
	 * A callback function that is called when the positive action is
	 * triggered.
	 * @returns void
	 */
	positiveAction: () => void;
	/**
	 * A callback function that is called when the negative action is
	 * triggered.
	 * @returns void
	 */
	negativeAction: () => void;
	/**
	 * The label of the positive action.
	 * @example "Confirm"
	 */
	positiveActionLabel: string;
	/**
	 * The label of the negative action.
	 * @example "Cancel"
	 */
	negativeActionLabel: string;
	/**
	 * The size of the modal.
	 */
	size?: "small" | "large" | "extralarge" | "full" | "auto";
}
/**
 * This is a confirmation modal that is used to confirm an action.
 * THIS IS THE Confirmation Modal, use Content Modal instead.
 * @deprecated
 */
const ConfirmationModal = (props: PropsWithChildren<BaseProps>) => {
	const { size = "small" } = props;
	const content = (
		<Text className={css.message} size="paragraph-1" weight="semi-bold">
			{props.children}
		</Text>
	);

	const buttons = (
		<div className={css.buttons}>
			<Button size="large" key="negative" color="blue" onClick={props.negativeAction}>
				{props.negativeActionLabel}
			</Button>
			<Button size="large" key="positive" color="green" onClick={props.positiveAction}>
				{props.positiveActionLabel}
			</Button>
		</div>
	);

	return <Modal size={size} buttons={buttons} handleClose={props.negativeAction} content={content} />;
};

export default ConfirmationModal;
